import { CloseOutlined } from "@ant-design/icons";
import React, { useState, useEffect, useCallback } from "react";
import AiAgent from "../../../pages/MainPage/frames/Formily/src/icons/aiAgent.tsx";
import {
	useDSL,
	useEdgesInteractions,
	useNodesInteractions,
  useNodeDataUpdate,
	useNodesReadOnly,
	usePanelInteractions,
	useSelectionInteractions,
	useShortcuts,
	useWorkflow,
	useWorkflowInit,
	useWorkflowReadOnly,
} from "../hooks";
import { useWorkflowStore } from "../store";
import _AiChat from "./AiChat.jsx";
import {
	applyOperations,
	restoreOperationsId,
	simplifyFlowWithMapping,
} from "./utils";

const AiChat = ({ nodes, edges }) => {
	const [showAiPanel, setShowAiPanel] = useState(false);
	const workflowStore = useWorkflowStore();
	const { isPreview, prjData } = workflowStore.getState();
	const { handleNodeAdd, handleNodeDelete } = useNodesInteractions();
  const { handleNodeDataUpdate } = useNodeDataUpdate();
	const { flow: simpleFlow, shortToLong } = simplifyFlowWithMapping({
		nodes,
		edges,
	});

	// 提供修改 wfMap 的方法
	const updateWfMap = useCallback(
		(aiResult) => {
			const flowJson = {
				nodes,
				edges,
			};

			// 3 恢复ID
			const realOps = restoreOperationsId(aiResult.operations, shortToLong);
			// 4 修改流程
			const newFlow = applyOperations(flowJson, realOps, {
				handleNodeAdd,
				handleNodeDelete,
        handleNodeDataUpdate
			});
			console.log(newFlow);
		},
		[nodes, edges, shortToLong, handleNodeAdd, handleNodeDelete, handleNodeDataUpdate],
	);

	return (
		<>
			{/* AI 助手按钮 */}
			{!showAiPanel && !isPreview && (
				<div
					className="fixed right-6 bottom-6 w-[46px] height-[46px] rounded-full bg-white shadow-[0_2px_8px_rgba(0,0,0,0.15)] flex items-center justify-center cursor-pointer z-10 transition-all duration-300 ease-in-out hover:shadow-[0_4px_12px_rgba(0,0,0,0.25)] group"
					onClick={() => setShowAiPanel(true)}
				>
					<div className="transition-transform duration-300 ease-in-out group-hover:rotate-45">
						<AiAgent width={32} height={32} />
					</div>
				</div>
			)}

			{/* AI 助手面板 */}
			{showAiPanel && (
				<div className="fixed right-0 bottom-0 w-[600px] h-[calc(100vh-220px)] bg-white shadow-[0_4px_16px_rgba(0,0,0,0.15)] rounded-t-lg z-10 flex flex-col overflow-hidden">
					{/* 面板头部 */}
					<div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 text-base font-medium text-black">
						<span>业务流程AI助手</span>
						<CloseOutlined
							className="cursor-pointer text-base hover:text-blue-500 transition-colors"
							onClick={() => setShowAiPanel(false)}
						/>
					</div>

					{/* 面板内容 */}
					<div className="flex-1 overflow-auto">
						<_AiChat
							style={{ height: "100%" }}
							prjId={prjData.prjId}
							sVer={prjData.sVer}
							scene={"EDIT_BF"}
							updateWfMap={updateWfMap}
							simpleFlow={simpleFlow}
						/>
					</div>
				</div>
			)}
		</>
	);
};

export default AiChat;
